
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom/dist';
import AddBrand from '../../core/modals/inventory/addbrand';
import EditBrand from '../../core/modals/inventory/editbrand';
import Swal from 'sweetalert2';
import Table from '../../core/pagination/datatable'
// import Select from 'react-select';
// import Sliders from 'feather-icons-react/build/IconComponents/Sliders';
import { ChevronUp, PlusCircle, RotateCcw } from 'feather-icons-react/build/IconComponents';
// import { DatePicker } from 'antd';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import ImageWithBasePath from '../../core/img/imagewithbasebath';
import { setToogleHeader } from '../../core/redux/action';
import withReactContent from 'sweetalert2-react-content';
import Axios from 'axios';
import { API_BASE_URL, DEL_BRAND, GET_BRAND, IMAGE_URL_IBIZ } from "../../Config";
import { setbrand_list } from "../../core/redux/action";
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { getUserPermissions } from "../../UserPermissions";
import SpinLoader from "../loader/SpinLoader";

const BrandList = () => {

    const [userDataSession, setUserDataSession] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        const userDataString = sessionStorage.getItem("userData");
        if (userDataString) {
            const userData = JSON.parse(userDataString);
            setUserDataSession(userData);
        } else {
            console.log("User data not found in sessionStorage");
            navigate('/');
        }
    }, []);

    const dataSource = useSelector((state) => state.brand_list);
    const dispatch = useDispatch();
    const data = useSelector((state) => state.toggle_header);

    const [searchQuery, setSearchQuery] = useState('');
    const [loading, setLoading] = useState(false);

    const [permissions, setPermissions] = useState({
        isRead: 'd-none',
        isWrite: 'd-none',
        isDelete: 'd-none',
        isExport: 'd-none'
    });
    
    useEffect(() => {
        const perms = getUserPermissions("Brands");
        setPermissions(perms);
    }, []);

    useEffect(() => {
        if (userDataSession && userDataSession.OrgId) {
            setLoading(true);

            Axios.get(`${API_BASE_URL}${GET_BRAND}?OrgId=${userDataSession.OrgId}`)
                .then(response => {
                    if (response.data.Status) {
                        dispatch(setbrand_list(response.data.ResultData));
                        setLoading(false);
                    } else {
                        console.error('Error fetching data:', response.data.Message);
                        setLoading(false);
                    }
                })
                .catch(error => {
                    console.error('Error fetching data:', error);
                    setLoading(false);
                });
        }
    }, [dispatch, userDataSession]);

    const renderTooltip = (props) => (
        <Tooltip id="pdf-tooltip" {...props}>
            Pdf
        </Tooltip>
    );
    const renderExcelTooltip = (props) => (
        <Tooltip id="excel-tooltip" {...props}>
            Excel
        </Tooltip>
    );
    const renderPrinterTooltip = (props) => (
        <Tooltip id="printer-tooltip" {...props}>
            Printer
        </Tooltip>
    );
    const renderRefreshTooltip = (props) => (
        <Tooltip id="refresh-tooltip" {...props}>
            Refresh
        </Tooltip>
    );
    const renderCollapseTooltip = (props) => (
        <Tooltip id="refresh-tooltip" {...props}>
            Collapse
        </Tooltip>
    );

    const columns = [

        {
            title: "Brand",
            dataIndex: "Name",
            sorter: (a, b) => a.Name.length - b.Name.length,
            render: (record) => (record ? record : 'N/A'),
        },

        {
            title: "Logo",
            dataIndex: "Filepath",
            render: (filepath, record) => (
                <div>
                    {filepath ? (
                        <img
                            className="rounded"
                            src={`${IMAGE_URL_IBIZ}${filepath}`}
                            alt=""
                            style={{ width: '3.6rem' }}
                        />
                    ) : (
                        <div
                            style={{
                                width: '3.6rem',
                                height: '3.6rem',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                backgroundColor: 'FF9F43',
                                borderRadius: '50%',
                                fontSize: '1.5rem',
                                color: '#fff',
                            }}
                        >
                            {record.Name ? record.Name.charAt(0).toUpperCase() : 'N/A'}
                        </div>
                    )}
                </div>
            ),
        },

        {
            title: "Code",
            dataIndex: "Code",
            sorter: (a, b) => a.Code.length - b.Code.length,
            render: (record) => (record ? record : 'N/A'),
        },

        {
            title: "Description",
            dataIndex: "Description",
            sorter: (a, b) => a.Description.length - b.Description.length,
            render: (record) => {
                const charLimit = 50;
                const truncatedText = record && record.length > charLimit 
                    ? `${record.substring(0, charLimit)}...` 
                    : record;
                    
                return (
                    <span title={record} style={{ maxWidth: '200px', display: 'inline-block', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {truncatedText === 'NULL' ? 'N/A' : truncatedText}
                    </span>
                );
            },
        },
        
        {
            title: 'Status',
            dataIndex: 'IsActive',
            render: (IsActive) => (
                <span className={`badge badge-${IsActive === true ? 'success' : 'danger'}`}>
                    {IsActive === true ? 'Active' : 'Inactive'}
                </span>
            ),
            sorter: (a, b) => (a.IsActive ? 1 : -1) - (b.IsActive ? 1 : -1),
        },

        {
            title: 'Actions',
            dataIndex: 'actions',
            key: 'actions',
            render: (text, record) => (
                <td className="action-table-data">
                    <div className="edit-delete-action">
                        <Link
                            className={`me-2 p-2 ${permissions.isWrite}`}
                            to="#"
                            data-bs-toggle="offcanvas"
                            data-bs-target="#offcanvasRightBrandEdit"
                            aria-controls="offcanvasRightBrandEdit"
                            onClick={() => showEditModal(record)}
                        >
                            <i data-feather="edit" className="feather-edit"></i>
                        </Link>
                        <Link 
                            className={`confirm-text p-2 ${permissions.isWrite}`}
                            to="#"
                        >
                            <i
                                data-feather="trash-2"
                                className="feather-trash-2"
                                onClick={() => showConfirmationAlert(record.Id)}
                            ></i>
                        </Link>
                    </div>
                </td>
            )
        },
    ]

    const filteredData = dataSource.filter(item =>
        item && // Check if item is defined
        (item.Name && item.Name.toLowerCase().includes(searchQuery.toLowerCase())) ||
        (item.Code && item.Code.toLowerCase().includes(searchQuery.toLowerCase())) ||
        (item.Type && item.Type.toLowerCase().includes(searchQuery.toLowerCase())) ||
        (item.Description && item.Description.toLowerCase().includes(searchQuery.toLowerCase()))
    );

    const [editBrandObj, setEditBrandObj] = useState([]);

    const showEditModal = (brandObj) => {
        setEditBrandObj(brandObj);
    };

    const MySwal = withReactContent(Swal);

    const showConfirmationAlert = (brandId) => {
        MySwal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#00ff00',
            cancelButtonColor: '#ff0000',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'Cancel'
        }).then((result) => {
            if (result.isConfirmed) {
                // Make a request to delete the brand
                deleteBrand(brandId);
            }
        });
    };

    const deleteBrand = (brandId) => {

        const requestData = { "Id": brandId, "UpdatedBy": userDataSession.UserId };

        Axios.post(`${API_BASE_URL}${DEL_BRAND}`, requestData)
            .then(response => {
                if (response.data.Status) {
                    // Show success message
                    MySwal.fire({
                        title: 'Deleted!',
                        text: 'Brand has been deleted.',
                        icon: 'success',
                        confirmButtonColor: '#00ff00',
                    }).then(() => {
                        // Reload the page after the user clicks "OK"
                        window.location.reload();
                    });
                    // Optionally, you can update the brand list after deletion
                } else {
                    // Show error message
                    MySwal.fire({
                        title: 'Error',
                        text: 'Failed to delete brand.',
                        icon: 'error',
                        confirmButtonColor: '#00ff00',
                    });
                }
            })
            .catch(error => {
                console.error('Error deleting brand:', error);
                // Show error message
                MySwal.fire({
                    title: 'Error',
                    text: 'Failed to delete brand.',
                    icon: 'error',
                    confirmButtonColor: '#00ff00',
                });
            });
    };

    const handleDownloadExcel = () => {
        if (data.length === 0) {
            return; // Don't download if there is no data
        }

        // Create a new workbook
        const wb = XLSX.utils.book_new();

        // Convert your data to worksheet format
        const wsData = dataSource?.map((item) => ({
            'Name': item.Name,
            'Code': item.Code,
            'Created Date': item.CreatedOn,
            'Dscription': item.Description,
        }));

        const ws = XLSX.utils.json_to_sheet(wsData);

        // Add the worksheet to the workbook
        XLSX.utils.book_append_sheet(wb, ws, 'BrandsData');

        // Save the workbook to a file
        XLSX.writeFile(wb, 'BrandsData.xlsx');
    };

    const generatePDF = () => {
        const doc = new jsPDF();

        // Set properties for PDF
        doc.setProperties({
            title: 'Brands Data',
            author: 'Your Name',
            creator: 'Your Application'
        });

        // Add data to PDF
        const tableData = []; // Your data array here

        // Add a header row
        const headers = ['Name', 'Code', 'Description', 'Created Date'];
        tableData.push(headers);

        // Add rows
        dataSource.forEach(item => {
            const row = [];
            row.push(item.Name, item.Code, item.Description, item.CreatedOn);
            tableData.push(row);
        });

        // Generate table
        doc.autoTable({
            head: [headers],
            body: tableData.slice(1),
        });

        // Save the PDF
        doc.save('BrandsData.pdf');
    };

    const handleReload = (e) => {
        e.preventDefault();
        window.location.reload();
    }

    return (
        <div>
            <div className="page-wrapper">
                <div className="content">
                    <div className="page-header">
                        <div className="add-item d-flex">
                            <div className="page-title">
                                <h4>Brand</h4>
                                <h6>Manage your brands</h6>
                            </div>
                        </div>
                        <ul className="table-top-head">
                            <li className={`${permissions.isExport}`}>
                                <OverlayTrigger placement="top" overlay={renderTooltip}>
                                    <Link  onClick={generatePDF}>
                                        <ImageWithBasePath src="assets/img/icons/pdf.svg" alt="img" />
                                    </Link>
                                </OverlayTrigger>
                            </li>
                            <li className={`${permissions.isExport}`}>
                                <OverlayTrigger placement="top" overlay={renderExcelTooltip}>
                                    <Link data-bs-toggle="tooltip" data-bs-placement="top" onClick={handleDownloadExcel}>
                                        <ImageWithBasePath src="assets/img/icons/excel.svg" alt="img" />
                                    </Link>
                                </OverlayTrigger>
                            </li>
                            <li>
                                <OverlayTrigger placement="top" overlay={renderPrinterTooltip}>

                                    <Link data-bs-toggle="tooltip" data-bs-placement="top">
                                        <i data-feather="printer" className="feather-printer" />
                                    </Link>
                                </OverlayTrigger>
                            </li>
                            <li>
                                <OverlayTrigger placement="top" overlay={renderRefreshTooltip}>

                                    <Link data-bs-toggle="tooltip" data-bs-placement="top" onClick={handleReload}>
                                        <RotateCcw />
                                    </Link>
                                </OverlayTrigger>
                            </li>
                            <li>
                                <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>

                                    <Link
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        id="collapse-header"
                                        className={data ? "active" : ""}
                                        onClick={() => { dispatch(setToogleHeader(!data)) }}
                                    >
                                        <ChevronUp />
                                    </Link>
                                </OverlayTrigger>
                            </li>
                        </ul>
                        <div className={`page-btn ${permissions.isWrite}`}>
                            <Link
                                to="#"
                                className="btn btn-added"
                                data-bs-toggle="offcanvas"
                                data-bs-target="#offcanvasRightBrandAdd"
                                aria-controls="offcanvasRightBrandAdd"
                            >
                                <PlusCircle className="me-2" />
                                Add New Brand
                            </Link>
                        </div>
                    </div>
                    {/* /product list */}
                    <div className="card table-list-card">
                        <div className="card-body">
                            <div className="table-top">
                                <div className="search-set">
                                    <div className="search-input">
                                        <input
                                            type="text"
                                            placeholder="Search"
                                            className="form-control form-control-sm formsearch"
                                            value={searchQuery}
                                            onChange={(e) => setSearchQuery(e.target.value)}
                                        />
                                        <Link to className="btn btn-searchset">
                                            <i data-feather="search" className="feather-search" />
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            
                            <div className="table-responsive">
                                {loading ? (
                                    // <div className="loader m-auto"></div>
                                    <SpinLoader/>
                                ) : (
                                    <Table columns={columns} dataSource={filteredData} />
                                )}
                            </div>
                        </div>
                        {/* /product list */}
                    </div>
                </div>
            </div>
            <AddBrand />
            <EditBrand brandObj={editBrandObj} />
        </div>
    )
}



export default BrandList;
